// Suggested vs quoted, for one traslado.
//
// `suggested` is what the system proposed from the route alone (Google km and
// casetas, the suggested food), priced with the same compute_traslado_estimate
// as the quote. It is frozen into traslado_orders.estimate.suggested at save
// time, so any hand edit — different casetas, extra food, a negotiated driver
// payment — shows up as a difference. Km are not editable, so not compared.
// Quotes saved before this existed have no `suggested`.
//
// Regreso del chofer is not compared: it has no suggestion (bus, plane, or
// nothing when the driver returns with another traslado). The suggested total
// is priced with the quote's own regreso, so it cancels out.

const n = (v) => (v == null || v === "" ? null : Number(v));

// Differences under 50 centavos (1 km) are rounding, not an edit.
const differs = (a, b, tol) => a != null && b != null && Math.abs(a - b) > tol;

export function quoteComparison(estimate, driverExtra) {
  const s = estimate?.suggested;
  if (!s) return null;
  const e = estimate;
  // The driver payment actually agreed; the quote's total moves with it.
  const chofer = n(driverExtra) ?? n(e.suggested_extra);
  const total =
    n(e.total) != null && chofer != null && n(e.suggested_extra) != null
      ? n(e.total) - n(e.suggested_extra) + chofer
      : n(e.total);

  const rows = [
    { key: "chofer", label: "Chofer", suggested: n(s.suggested_extra), quoted: chofer, tol: 0.5 },
    { key: "gasolina", label: "Gasolina", suggested: n(s.fuel_cost), quoted: n(e.fuel_cost), tol: 0.5 },
    { key: "casetas", label: "Casetas", suggested: n(s.tolls), quoted: n(e.tolls), tol: 0.5 },
    { key: "comida", label: "Comida", suggested: n(s.comida), quoted: n(e.comida), tol: 0.5 },
    { key: "total", label: "Total", suggested: n(s.total), quoted: total, tol: 0.5 },
  ].map((r) => ({
    ...r,
    diff: r.suggested != null && r.quoted != null ? r.quoted - r.suggested : null,
    changed: differs(r.quoted, r.suggested, r.tol),
  }));

  return { rows, adjusted: rows.some((r) => r.key !== "total" && r.changed) };
}
